/*
  Buy box: two clear steps.
  1. Size cards — enhances the theme's size buttons with per-serve price, savings
     and a "Best to start" tag (data from #mx-size-data, output by the product template).
  2. Purchase option — relabelled in CSS (modex-editorial.css) so this script never
     touches the Appstle widget's DOM (doing so blocked its price updates).
  Re-applies when the theme or Appstle re-render after a variant change.
*/
(function () {

  function sizeData() {
    var el = document.getElementById('mx-size-data');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }

  function enhanceSizes() {
    var data = sizeData();
    if (!data) return;
    document.querySelectorAll('.main-product__details .variant-picker__fieldset').forEach(function (fs) {
      var labels = fs.querySelectorAll('.variant-option__label');
      var matched = 0;
      labels.forEach(function (label) {
        var text = label.querySelector('.variant-option__label-text');
        if (!text) return;
        var key = text.textContent.trim();
        var d = data[key];
        if (!d) return;
        matched++;
        if (label.getAttribute('data-mx-key') && label.nextElementSibling && label.nextElementSibling.classList.contains('mx-size__card')) return;
        label.setAttribute('data-mx-key', key);
        label.classList.add('mx-size');
        // Card content lives in a sibling overlay: the label and its text stay untouched,
        // because apps (Appstle) read them to detect the selected variant.
        var card = document.createElement('span');
        card.className = 'mx-size__card';
        card.setAttribute('aria-hidden', 'true');
        card.innerHTML =
          (d.tag || d.start ? '<span class="mx-size__tag">' + (d.tag || 'Best to start') + '</span>' : '') +
          '<span class="mx-size__l">' + d.size + '</span>' +
          '<span class="mx-size__s">' + (d.sub || (d.serves + ' serves')) + '</span>' +
          '<span class="mx-size__meta"><span class="mx-size__p">' + d.per + ' / ' + (d.unit || 'serve') + '</span>' +
          (d.save >= 5 ? '<span class="mx-size__save">Save ' + d.save + '%</span>' : '') + '</span>';
        label.parentNode.insertBefore(card, label.nextSibling);
        label.parentNode.classList.add('mx-size-wrap');
      });
      if (matched) {
        fs.classList.add('mx-sizes');
        var legend = fs.querySelector('legend');
        if (legend && !legend.getAttribute('data-mx')) { legend.setAttribute('data-mx', '1'); legend.textContent = '1 · ' + (data._legend || 'Choose your size'); }
      }
    });
  }

  // Flavour pill sits on the same line as the price
  function flavourRow() {
    var pill = document.querySelector('.main-product__details .mx-flavour');
    if (!pill || pill.closest('.mx-price-row')) return;
    var price = document.querySelector('.main-product__details .sp-price') || document.querySelector('.main-product__details .main-product__price');
    if (!price) return;
    var row = document.createElement('div');
    row.className = 'mx-price-row';
    price.parentNode.insertBefore(row, price);
    row.appendChild(price);
    var holder = pill.closest('.shopify-block') || pill.parentNode;
    row.appendChild(pill);
    if (holder && holder !== pill && !holder.textContent.trim()) holder.style.display = 'none';
  }

  // Mobile sticky add to cart: only after the science section has been scrolled past
  (function gate() {
    var mq = window.matchMedia('(max-width: 749px)');
    function bar() { return document.querySelector('.sticky-add-to-cart'); }
    function target() {
      return document.querySelector('.bi, .hxs, .tc') || document.querySelector('[id$="__main-product"]');
    }
    var ticking = false;
    function check() {
      ticking = false;
      var b = bar(), t = target();
      if (!b) return;
      if (!mq.matches || !t) { b.classList.remove('mx-gated'); return; }
      b.classList.toggle('mx-gated', t.getBoundingClientRect().bottom > 0);
    }
    function queue() { if (!ticking) { ticking = true; requestAnimationFrame(check); } }
    window.addEventListener('scroll', queue, { passive: true });
    window.addEventListener('resize', queue);
    check(); setTimeout(check, 1200);
  })();

  function run() { enhanceSizes(); flavourRow(); }

  // Subscription consent: add a "Read full terms" toggle once Shopify shows it
  function consent() {
    var c = document.getElementById('shopify-buyer-consent');
    if (!c || c.classList.contains('hidden')) return;
    if (!c.nextElementSibling || !c.nextElementSibling.classList.contains('mx-consent-more')) {
      var b = document.createElement('button');
      b.type = 'button'; b.className = 'mx-consent-more'; b.textContent = 'Read full terms';
      b.addEventListener('click', function () { var open = c.classList.toggle('mx-open'); b.textContent = open ? 'Show less' : 'Read full terms'; });
      c.parentNode.insertBefore(b, c.nextSibling);
    }
  }
  var consentEl = document.getElementById('shopify-buyer-consent');
  if (consentEl) new MutationObserver(function () {
    consent();
    var b = consentEl.nextElementSibling;
    if (b && b.classList.contains('mx-consent-more')) b.style.display = consentEl.classList.contains('hidden') ? 'none' : '';
  }).observe(consentEl, { attributes: true, attributeFilter: ['class'] });

  // Mobile gallery: thin progress line under the image (multiple images only)
  function dots() {
    document.querySelectorAll('.main-product__media .product-media-carousel__main .swiper').forEach(function (el) {
      var sw = el.swiper;
      if (!sw || el.__mxProg) return;
      var n = el.querySelectorAll(':scope > .swiper-wrapper > .swiper-slide').length;
      if (n < 2) return;
      el.__mxProg = true;
      var bar = document.createElement('div');
      bar.className = 'mx-progress';
      bar.setAttribute('aria-hidden', 'true');
      bar.innerHTML = '<span class="mx-progress__fill"></span>';
      var fill = bar.firstChild;
      fill.style.width = (100 / n) + '%';
      el.parentNode.insertBefore(bar, el.nextSibling);
      function upd() { var a = sw.realIndex || sw.activeIndex || 0; fill.style.transform = 'translateX(' + (a * 100) + '%)'; }
      sw.on('slideChange', upd); upd();
    });
  }
  var dTries = 0; (function waitDots() { dots(); if (++dTries < 20) setTimeout(waitDots, 300); })();

  // Mobile: "Subscription detail" opens on tap instead of always showing
  document.addEventListener('click', function (e) {
    var p = e.target.closest && e.target.closest('.appstle_sub_widget .appstle-tootltip-parent');
    if (!p || !window.matchMedia('(max-width: 749px)').matches) return;
    if (e.target.closest('.appstle_tooltip a')) return;
    e.preventDefault();
    p.classList.toggle('mx-open');
  });
  var queued = false;
  function queue() { if (queued) return; queued = true; requestAnimationFrame(function () { queued = false; run(); }); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run); else run();
  // Watch only the size picker (never the Appstle widget, which has its own observer)
  function watch() {
    document.querySelectorAll('.main-product__details variant-picker, .main-product__details .variant-picker__fieldset').forEach(function (el) {
      if (el.__mxObs) return;
      el.__mxObs = new MutationObserver(queue);
      el.__mxObs.observe(el, { childList: true, subtree: true });
    });
  }
  watch();
  document.addEventListener('change', function (e) {
    setTimeout(function () { watch(); run(); }, 50);
    if (e.isTrusted !== false && e.target && e.target.closest && e.target.closest('.variant-picker__fieldset, variant-picker')) syncVariantId();
  });

  // Appstle detects variant changes by watching the [name="id"] *attribute*; the theme
  // only updates the input's value property, so Appstle can miss changes (it lags a step).
  // Mirror the value into the attribute once the theme has updated it.
  function syncVariantId() {
    [60, 250, 700].forEach(function (ms) {
      setTimeout(function () {
        document.querySelectorAll('form[action*="/cart/add"] [name="id"]').forEach(function (input) {
          if (!input.value) return;
          if (input.getAttribute('value') !== input.value) input.setAttribute('value', input.value);
          // Appstle re-renders prices on a 'change' from its product form; nudge it with the current id
          if (input.__mxLast !== input.value || ms === 700) {
            input.__mxLast = input.value;
            input.dispatchEvent(new Event('change', { bubbles: true }));
          }
        });
      }, ms);
    });
  }
  document.addEventListener('shopify:section:load', run);
})();
